import { FlashTriangleIcon } from './FlashTriangleIcon';

/**
 * author: tetzla
 * id E5881C80-1B80-472E-AFD9-A337D38C7A2F
 * name flash-triangle
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-triangle.svg
 * tags
 * - Home Automation 
 */
export const HighVoltageIcon = FlashTriangleIcon;
export default HighVoltageIcon